<template>
<b-dropdown right no-caret>
  <template slot="button-content" v-if='isShow'>
    <img  class="info-icon" src="static/img/assets/edit.png">
  </template>
  <b-dropdown-item :to="{ name: 'OneRegist', params: { item: this.getOneItem, id: this.getKey } }">{{$t('popTitleStr9')}}</b-dropdown-item>
  <b-dropdown-item @click="onClickDelete">{{$t('deleteStr')}}</b-dropdown-item>
</b-dropdown>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'OneDropDown',
  props: {
    item: {
      type: Object
    },
    id: {
      type: String
    }
  },
  data () {
    return {
      isShow: false,
      removeTarget: {
        id: '',
        target: ''
      }
    }
  },
  computed: {
    ...mapGetters('ones/', [
      'getCurrent1on1s'
    ]),
    getOneItem: function () {
      return this.item
    },
    getKey: function () {
      return this.id
    }
  },
  beforeMount: function () {
    if (Object.keys(this.getCurrent1on1s).filter(x => x === this.getKey).length > 0) {
      this.isShow = true
    }
  },
  methods: {
    ...mapActions({
      removeItem: 'REMOVE_ITEM'
    }),
    ...mapActions('ones/', {
      removeOneDate: 'REMOVE_ONEDATE'
    }),
    onClickDelete: function () {
      const $t = this.$t
      this.removeTarget.id = this.getKey
      this.removeTarget.target = '1on1s'
      // const emitFunction = this.$emit('reset-target')
      this.$swal({
        // sweetAlartの処理
        title: $t('popTitleStrType'),
        text: $t('doDeleteStr'),
        showCancelButton: true,
        cancelButtonColor: '#f64846',
        type: 'warning',
        confirmButtonClass: 'btn btn-success',
        cancelButtonClass: 'btn btn-danger',
        reverseButtons: false,
        animation: false,
        customClass: 'animated fadeInUp',
        // customClass: 'animated flipInX',
        width: '35rem',
        position: 'center',
        // toast: true,
        allowOutsideClick: false,
        padding: '2rem'
        // timer: 3000
      }).then((result) => {
        if (result.value) {
          // okが押下されたら
          console.log(this.getCurrent1on1s[this.removeTarget.id])
          this.removeOneDate(this.getCurrent1on1s[this.removeTarget.id].date.replace(/\//g, '-'))
          this.removeItem(this.removeTarget)
          this.$swal({
            // title: $t('compDeleteStr'),
            title: $t('popMessageStr9'),
            type: 'success',
            animation: false,
            customClass: 'animated fadeInUp',
            // customClass: 'animated flipInX',
            width: '35rem',
            position: 'center',
            // toast: true,
            padding: '2rem',
            timer: 3000
          })
        }
      })
      this.$router.push('/one/list')
    }
  }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/One/OneDropDown.vue